import { COLORS, RANGES, UNITS, WORKTOPS } from './cloudinaryImages'
import { RANGE_PRICES, WORKTOP_PRICES } from './prices'

const sections = [
  {
    id: 'range',
    type: 'range',
    title: 'Keittiömallit',
    shortTitle: 'Keittiömallit',
    description: 'Valitse mieleisesi malli alla olevista vaihtoehdoista.',
    tooltip: {
      title: 'Keittiömallistomme',
      description: [
        'Valikoimastamme löytyy keittiömalleja jokaiseen tyyliin ja makuun. Ovimallien hinta saattaa vaihdella valitun värin ja materiaalin mukaan.',
      ],
    },
    cards: [
      {
        title: 'Nordic Nature',
        collection: 'Novart',
        description:
          'Kaunis, ruskeaksi petsattu viiluovi elävöittää keittiötä luonnollisella pinnan vaihtelulla. Ovi antaa keittiölle modernin ilmeen ja kutsuu luonnon kotiisi.',
        colors: COLORS.nordicNature,
        prices: {
          small: RANGE_PRICES.nordicNature[0],
          medium: RANGE_PRICES.nordicNature[1],
          large: RANGE_PRICES.nordicNature[2],
        },
        image: RANGES.nordicNature,
        filterWorktops: [
          'Laminaatti (Nordic Nature)',
          'Kivitaso (Nordic Nature)',
          'Ruostumaton teräs',
        ],
      },
      {
        title: 'Nordic Elegance',
        collection: 'Novart',
        description:
          'Skandinaavinen klassikko modernilla otteella.Näyttävässä massiivitammisessa ovimallissa jokainen puusäle toimii vetimenä ja tekee pinnasta yhtenäisen.',
        colors: COLORS.nordicElegance,
        prices: {
          small: RANGE_PRICES.nordicElegance[0],
          medium: RANGE_PRICES.nordicElegance[1],
          large: RANGE_PRICES.nordicElegance[2],
        },
        image: RANGES.nordicElegance,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Willa',
        collection: 'Novart',
        description:
          'Yhdistele klassikkoelementtejä moderniin nostaen rakkaimmat esineet rohkeasti esille. Keittiön merkittävä elementti ovipääty on saatavilla väreissä Huurre, Pilvi, Ukkonen, Tähkä ja Havu.',
        colors: COLORS.willa,
        prices: {
          small: RANGE_PRICES.willa[0],
          medium: RANGE_PRICES.willa[1],
          large: RANGE_PRICES.willa[2],
        },
        image: RANGES.willa,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Maalatut sileät',
        collection: 'Novart',
        description:
          'Valikoimasta on valittavissa runsaasti erilaisia tyylejä muotoilun mukaan. Keittiöovet toimivat hyvin kahvoilla tai ilman. Saatavilla kaikissa Luonto-värikokoelman väreissä.',
        colors: COLORS.maalatutSileat,
        prices: {
          small: RANGE_PRICES.maalatutSileat[0],
          medium: RANGE_PRICES.maalatutSileat[1],
          large: RANGE_PRICES.maalatutSileat[2],
        },
        image: RANGES.maalatutSileat,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Maalatut kehykselliset',
        collection: 'Novart',
        description:
          'Laaja valikoima romanttisesta klassiseen keittiötyyliin, joka voidaan muotoilla oven kehyksen muodoilla, väreillä ja kahvalla. Saatavilla kaikissa Luonto-värikokoelman väreissä.',
        colors: COLORS.maalatutKehys,
        prices: {
          small: RANGE_PRICES.maalatutKehys[0],
          medium: RANGE_PRICES.maalatutKehys[1],
          large: RANGE_PRICES.maalatutKehys[2],
        },
        image: RANGES.maalatutKehys,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Maalatut vedinuralliset',
        collection: 'Novart',
        description:
          'Minimalistinen keittiö, jonka oveen on integroitu kahva, joka luo näyttävän linjakkuuden. Tyylikäs ja moderni valinta.',
        colors: COLORS.maalatutVedinuralliset,
        prices: {
          small: RANGE_PRICES.maalatutVedinuralliset[0],
          medium: RANGE_PRICES.maalatutVedinuralliset[1],
          large: RANGE_PRICES.maalatutVedinuralliset[2],
        },
        image: RANGES.maalatutVedinuralliset,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Puu- ja viilu',
        collection: 'Novart',
        description:
          'Oven hienovarainen puusyykuvio elävöittää pintaa ja tekee ovesta skandinaaviseen makuun soveltuvan.',
        colors: COLORS.puujaViilu,
        prices: {
          small: RANGE_PRICES.puujaViilu[0],
          medium: RANGE_PRICES.puujaViilu[1],
          large: RANGE_PRICES.puujaViilu[2],
        },
        image: RANGES.puujaViilu,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Melamiini- ja laminaatti',
        collection: 'Novart',
        description:
          'Luo upea kokonaisuus tyylistä tinkimättä helppohoitoisella ja kovaakin kulutusta kestävällä materiaalilla. Sopiva myös hieman huolettomammalle asujalle.',
        colors: COLORS.melamiiniLaminaatti,
        prices: {
          small: RANGE_PRICES.melamiiniLaminaatti[0],
          medium: RANGE_PRICES.melamiiniLaminaatti[1],
          large: RANGE_PRICES.melamiiniLaminaatti[2],
        },
        image: RANGES.melamiiniLaminaatti,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
      {
        title: 'Supermattalaminaatti',
        collection: 'Novart',
        description:
          'Tyylikäs ja kestävä valinta keittiöön. Supermatan pinnasta valo ei heijastu ja himmeässä pinnassa sormenjäljet eivät näy helposti.',
        colors: COLORS.supermattalaminaatti,
        prices: {
          small: RANGE_PRICES.supermattalaminaatti[0],
          medium: RANGE_PRICES.supermattalaminaatti[1],
          large: RANGE_PRICES.supermattalaminaatti[2],
        },
        image: RANGES.supermattalaminaatti,
        filterWorktops: ['Laminaatti', 'Kivitaso', 'Ruostumaton teräs'],
      },
    ],
  },
  {
    id: 'units',
    title: 'Keittiön koko',
    shortTitle: 'Keittiön koko',
    type: 'units',
    description: 'Valitse keittiön koko.',
    tooltip: {
      title: 'Keittiön koko',
      description: [
        'Pienet keittiöt ovat yleensä I-muotoisia kaappien ollessa yhdellä seinällä, kooltaan noin 10 m2.',
        'Keskikokoiset keittiöt ovat useimmiten L-muotoisia tai neliöitä, kooltaan noin 15 m2.',
        'Suuret keittiöt ovat kooltaan noin 20 m2 tai enemmän sisältäen saarekkeen.',
        'Hinnat ovat laskettu ilman kodinkoneita ja kuvan piirroksen kaapistojen lukumäärän mukaan.',
      ],
    },
    cards: [
      {
        type: 'small',
        title: 'Pieni alkaen',
        price: 0,
        image: UNITS.small,
      },
      {
        type: 'medium',
        title: 'Keskikokoinen alkaen',
        price: 0,
        image: UNITS.medium,
      },
      {
        type: 'large',
        title: 'Suuri alkaen',
        price: 0,
        image: UNITS.large,
      },
    ],
  },
  {
    id: 'worktops',
    title: 'Työtasot',
    type: 'simple',
    description: 'Valitse haluamasi keittiötason tyyli.',
    tooltip: {
      title: 'Työtasomallistomme',
      description: [
        'Valitse laminaatin, puun, kivitason ja teräksen väliltä saadaksesi ajatuksen hintatasosta. Tarjoamme laajan valikoiman työtasoja eri materiaaleissa, joten voit valita alla olevien tasojen sijaan jonkin muun.',
      ],
    },
    cards: [
      {
        title: 'Laminaatti (Nordic Nature)',
        description:
          'Helppohoitoinen, kestävä ja tyylikäs sekä edullinen valinta. Valikoimissamme on laminaattitasoja monilla eri väreillä sekä pintavaihtoehdoilla.',
        prices: {
          small: WORKTOP_PRICES.laminateNordicNature[0],
          medium: WORKTOP_PRICES.laminateNordicNature[1],
          large: WORKTOP_PRICES.laminateNordicNature[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Laminaatti',
        description:
          'Helppohoitoinen, kestävä ja tyylikäs sekä edullinen valinta. Valikoimissamme on laminaattitasoja monilla eri väreillä sekä pintavaihtoehdoilla.',
        prices: {
          small: WORKTOP_PRICES.laminate[0],
          medium: WORKTOP_PRICES.laminate[1],
          large: WORKTOP_PRICES.laminate[2],
        },
        image: WORKTOPS.laminate,
      },

      {
        title: 'Kivitaso',
        description:
          'Kestävimpiä materiaaleja maailmassa, luo ainutlaatuista ja aitoa tunnetta keittiöön. Valikoimassamme on kivi-, kvartsi- sekä graniittitasoja.',
        prices: {
          small: WORKTOP_PRICES.granite[0],
          medium: WORKTOP_PRICES.granite[1],
          large: WORKTOP_PRICES.granite[2],
        },
        image: WORKTOPS.granite,
      },
      {
        title: 'Kivitaso (Nordic Nature)',
        description:
          'Kestävimpiä materiaaleja maailmassa, luo ainutlaatuista ja aitoa tunnetta keittiöön. Valikoimassamme on kivi-, kvartsi- sekä graniittitasoja.',
        prices: {
          small: WORKTOP_PRICES.graniteNordicNature[0],
          medium: WORKTOP_PRICES.graniteNordicNature[1],
          large: WORKTOP_PRICES.graniteNordicNature[2],
        },
        image: WORKTOPS.granite,
      },
      {
        title: 'Ruostumaton teräs',
        description:
          'Erittäin hygieeninen materiaali, joka on helppo pitää puhtaana. Moderni vaihtoehto, johon on saatavilla myös kauniita pintakuviointeja.',
        prices: {
          small: WORKTOP_PRICES.stainless[0],
          medium: WORKTOP_PRICES.stainless[1],
          large: WORKTOP_PRICES.stainless[2],
        },
        image: WORKTOPS.stainless,
      },
    ],
  },
  {
    id: 'estimate',
    title: 'Estimat',
    type: 'summary',
    description: '',
    tooltip: {},
  },
]

export default sections
